<app-header></app-header>
<div class="container ">
  <div class="we-offer row mt-50 main-block" style="background: url(assets/home-1block.png);">
    <h1 style="font-size: 40px;">ЭКСПЕРТИЗА, ДОКУМЕНТАЦИЯ, ТЕХНИЧЕСКОЕ ОСВИДЕТЕЛЬСТВОВАНИЕ, АУДИТ</h1>
    <h2 class="grafit" >ООО &laquo;Протос Экспертиза&raquo; с 2006 года работает в области промышленной безопасности.</h2>

    <ul class="marked ml-50">
      <li>Собственная <strong>лаборатория неразрушающего контроля</strong></li>
      <li><strong>Опытные аттестованные эксперты</strong></li>
      <li>Полное <strong>соблюдение указанных сроков</strong></li>
      <li><strong>Сопровождение</strong> на всех этапах</li>
      <li><strong>Комплексные</strong> решения</li>
    </ul>
  </div>
  <h2>Экспертиза промышленной безопасности</h2>
  <div class="row col-mobile">
    <div class="col">
      <p>ООО &quot;Протос Экспертиза&quot; - <a class="underlined" href="https://www.gosnadzor.ru/service/list/reestr_licences_99fz/license.php?licNum=%D0%94%D0%AD-00-006706" target="_blank" title="ДЭ-00-006706">ДЭ-00-006706&nbsp;</a></p>

      <p style="text-align: center;"><a data-lightbox="gallery" href="/"><img src="/assets/img_26.png" title="Лицензия.jpg" /></a></p>

      <p>Проводим экспертизу <strong>промышленной безопасности:</strong></p>

      <ul class="marked ml-50">
        <li>технических устройств (ЭПБ ТУ);</li>
        <li>зданий и сооружений (ЭПБ ЗС);</li>
        <li>документации на техническое перевооружение (ЭПБ ТП);</li>
        <li>документации на консервацию, ликвидацию (ЭПБ КЛ);</li>
      </ul>

      <p><strong>В ШТАТЕ ОПЫТНЫЕ ЭКСПЕРТЫ</strong></p>
    </div>
    <div class="col links-bl">
      <a class="underlined mb-3-mobile" routerLink="/expertkltp">Проведение экспертизы промышленной безопасности всех объектов и документации КЛТП
      </a><a class="underlined mb-3-mobile" routerLink="/expprombez">Экспертиза промышленной безопасности
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/zis/">Экспертиза промышленной безопасности зданий и сооружений
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/tehus/">Экспертиза промышленной безопасности технических устройств применяемых на ОПО
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/expertpd/">Экспертиза промышленной безопасности проектной документации
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/expertdecl/">Экспертиза промышленной безопасности декларации промышленной безопасности
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/epb-kotlov/">Экспертиза промышленной безопасности котельной: ГРУ, котлов, газогорелочных устройств
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/epb-sosudov/">Экспертиза промышленной безопасности сосудов, работающих под давлением
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/epb-sosudov/epb-truboprovodov/">Экспертиза промышленной безопасности трубопроводов
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/epb-gazoprovodov/">Экспертиза промышленной безопасности газопроводов
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/epb-gpm/">Экспертиза промышленной безопасности кранов
    </a><a class="underlined mb-3-mobile" routerLink="/expprombez/teplpset/">Теплосеть ОПО: экспертиза промышленной безопасности, ввод в эксплуатацию теплосети, акт допуска</a>
    </div>
  </div>
  <h2>Разработка документации на консервацию, ликвидацию и техническое перевооружение опасных производственных объектов
  </h2>
  <div class="row col-mobile">
    <div class="col"><ul class="marked ml-50">
      <li><strong>Разрабатываем документацию на консервацию, ликвидацию, техническое перевооружение (КЛТП);</strong></li>
      <li>Проводим <strong>экспертизу промышленной безопасности документации;</strong></li>
      <li><strong>Оказываем содействие в подготовке исполнительной документации КЛТП.</strong></li>
      <li><strong>Вносим изменения в сведения РТН,</strong> производим исключение из реестра, а также снятие оборудования с учета.</li>
    </ul>

      <p><strong>ВСЕ РЕГИОНЫ, ВСЕ ОПО</strong></p>
    </div>
    <div class="col links-bl">
      <a routerLink="/proekt-likvidatsii-i-konservatsii-opo/likvidatsiya/" class="underlined mb-3">Ликвидация опасного производственного объекта</a>
      <a routerLink="/proekt-likvidatsii-i-konservatsii-opo/konservatsiya/" class="underlined mb-3">Консервация опасного производственного объекта</a>
      <a routerLink="/tehnicheskoe-perevooruzhenie-opo/" class="underlined">Техническое перевооружение ОПО</a>
    </div>
  </div>
  <h2>Техническое освидетельствование опасных производственных объектов: технических устройств, зданий и сооружений
  </h2>
  <div class="row col-mobile">
    <div class="col">
      <p>Проводим <strong>техническое освидетельствование и диагностирование </strong>устройств, используемых на ОПО:</p>

      <ul class="marked ml-50">
        <li>систем газоснабжения и газораспределения;</li>
        <li>паровых и водогрейных котлов, сосудов и резервуаров;</li>
        <li>трубопроводов пара и горячей воды, в т.ч. технологических;</li>
        <li>грузоподъемных механизмов, а также других опасных производственных объектов.</li>
      </ul>

      <p><strong>СОБСТВЕННАЯ ЛАБОРАТОРИЯ НЕРАЗРУШАЮЩЕГО КОНТРОЛЯ - ЛНК027А0032.</strong></p>

    </div>
    <div class="col links-bl">
      <a routerLink="/tekhnicheskoe-diagnostirovanie/td-gaz/" class="underlined">Диагностирование газопроводов и систем газопотребления, техническое освидетельствование газопроводов</a>
      <a routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-rezervuarov/" class="underlined">Диагностирование резервуаров для хранения нефтепродуктов</a>
      <a routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-kotlov/" class="underlined">Техническое освидетельствование и диагностирование котлов работающих под давлением</a>
      <a routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-zis/" class="underlined">Техническое обследование (диагностирование) зданий и сооружений</a>
      <a routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-sosudov/" class="underlined">Техническое освидетельствование сосудов работающих под давлением</a>
      <a routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-truboprovodov/" class="underlined">Техническое освидетельствование трубопроводов пара и горячей воды</a>
      <a routerLink="/tekhnicheskoe-diagnostirovanie/obsledovanie-gpm/" class="underlined">Техническое освидетельствование кранов и грузоподъемных сооружений</a>
    </div>
  </div>
  <h2>Аудит и идентификация ОПО</h2>
  <div class="row col-mobile">
    <div class="col">
      <p>Проводим <strong>аудит и идентификацию </strong>ОПО в соответствии с требованиями Ростехнадзора:</p>

      <ul class="marked ml-50">
        <li>определяем признаки и категорию опасности;</li>
        <li>определяем тип опасного производственного объекта и его наименование;</li>
        <li>предоставляем сведения, характеризующие опасный производственный объект;</li>
        <li>оказываем содействие в регистрации в реестре опасных производственных объектов с присвоением класса опасности.</li>
      </ul>

      <p><strong>РАБОТАЕМ С 2006 ГОДА</strong></p>
    </div>
    <div class="col links-bl">
      <a routerLink="/identifikaciya/" class="underlined mb-3">Идентификация опасных производственных объектов</a>
      <a routerLink="/audit/" class="underlined mb-3">Аудит опасных производственных объектов (ОПО)</a>
      <a routerLink="/pasport/" class="underlined">Разработка и восстановление паспортов оборудования ОПО</a>
    </div>
  </div>
<!--  <div class="row check-form pb-4 mt-5">-->
<!--    <h2 style="margin-top: 30px;">Плановые проверки 2025</h2>-->
<!--    <p>Узнайте, попала ли <b>ваша компания</b> в список проверок на 2025 год*</p>-->
<!--    <div class="form flex-row" style="gap: 20px;">-->
<!--    <input type="text" placeholder="ИНН вашей компании"><button class="call-me_btn">искать в базе проверок</button>-->
<!--      </div>-->
<!--    <p style="font-size: 12px; margin-top: 10px;">* Федеральная база проверок Ростехнадзора, Росприроднадзора, МЧС, Росохранатруда, Роспотребнадзор. Взято из официальных источников.</p>-->
<!--  </div>-->
  <app-reviews-block class="w-100"></app-reviews-block>
  <div class="benefits mt-5">
    <div class="benefit-block">
      <img src="assets/img_23.png" alt="">
      <h3>20 лет опыта</h3>
      <p>Мы эффективно сотрудничаем с Ростехнадзором, Росприроднадзором и МЧС, предоставляя нашим клиентам широкий спектр услуг в области промышленной, экологической и пожарной безопасности. Более того, список услуг постоянно расширяется, и поэтому мы сможем комплексно решить целый ряд проблем предприятия с документацией.</p>
      </div>
      <div class="benefit-block ">
        <img src="assets/img_24.png" alt="">

        <h3>Нам доверяют</h3>
        <p>Нашими клиентами уже стали сотни успешных российских и зарубежных компаний. Большинство из них сотрудничают с нами на постоянной основе, что подтверждает высокое качество оказываемых нами услуг. Присоединяйтесь и вы к постоянному сотрудничеству!</p>
        <img style="height: 90px;" class="h70-mobile" src="assets/img_27.png" alt="">
      </div>
    <div class="benefit-block">
        <img src="assets/img_25.png" alt="">
      <h3>Работаем со всей Россией</h3>
      <ul class="marked">
        <li>Центр</li>
        <li>Северо-Запад</li>
        <li>Юг</li>
        <li>Сибирь</li>
        <li>Дальний Восток</li>
        <li>Северный Кавказ</li>
        <li>Урал</li>
      </ul>
    </div>
    </div>
  <div class="accent-block mt-5">
    <div>C <span class="darkred">2006</span> года: <span class="darkred big">1525</span> клиентов из <span class="darkred big">70</span> регионов России
    </div>
  </div>
</div>
<app-footer></app-footer>
